import axiosClient from './axiosClient';

const importApi = {
  // expects FormData with `type` and `file`
  upload: (formData) =>
    axiosClient.post('/admin/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
};

export default importApi;
